module.exports = __webpack_public_path__ + "static/media/16.b3b14e01.jpg";